import {useMutation, UseMutationResult} from "@tanstack/react-query";
import {api} from "@/features/api";
import {clearAffiliateCode, getAffiliateCode} from "@/utils/affiliate-code";

const useSignByToken: () => UseMutationResult = () =>
  useMutation({
    // retry is set to 3 to allow for transient errors
    // such as network issues or server overload
    // to be retried before failing
    retry: 3,

    mutationFn: async () => {
      const affiliateCode = getAffiliateCode();

      const response = await api("TRENDARO_API_URL", true).post(
        `/users:signByToken`,
        affiliateCode ? {json: {affiliateCode}} : undefined,
      );

      if (!response.ok) {
        throw new Error("Nelze se přihlásit pomocí SSO.");
      }

      return true;
    },

    onSuccess: () => {
      clearAffiliateCode();
    },
  });

export default useSignByToken;
